import { Routes } from '@angular/router';


export const content: Routes = [
  {
    path: 'accueil',
    loadChildren: () => import('../../applications/menu/accueil/accueil.module').then((m) => m.AccueilModule),

  },
  {
    path: 'secu',
    loadChildren: () => import('../../applications/securite/securite.module').then((m) => m.SecuriteModule),

  },
  {
    path: 'admin',
    loadChildren: () => import('../../applications/admin/admin.module').then((m) => m.AdminModule),

  },
  {
    path: 'accueil-structure',
    loadChildren: () => import('../../applications/structure/structure.module').then((m) => m.StructureModule),

  },
  {
    path: 'accueil-candidat',
    loadChildren: () => import('../../applications/candidat/candidat.module').then((m) => m.CandidatModule),

  },
  {
    path: 'structure',
    loadChildren: () => import('../../applications/structure/structure.module').then((m) => m.StructureModule),

  },
  {
    path: 'demande',
    loadChildren: () => import('../../applications/structure/pageDemande/demande/demande.module').then((m) => m.DemandeModule),

  },
  {
    path: 'candidat',
    loadChildren: () => import('../../applications/candidat/candidat.module').then((m) => m.CandidatModule),

  },
  {
    path: 'candidat-faq',
    loadChildren: () => import('../../applications/faq/faq.module').then((m) => m.FaqModule),

  },

  {
    path: 'guide',
    loadChildren: () => import('../../applications/guide/guide.module').then((m) => m.GuideModule),

  },
  {
    path: 'candidature',
    loadChildren: () => import('../../applications/candidature/candidature.module').then((m) => m.CandidatureModule),

  },
  {
    path: 'simple-page',
    loadChildren: () => import('../../components/simple-page/simple-page.module').then((m) => m.SimplePageModule),
  },
  {
    path: 'single-page',
    loadChildren: () => import('../../components/single-page/single-page.module').then((m) => m.SinglePageModule),
  },
  {
    path: 'parametre',
    loadChildren: () => import('../../applications/parametre/parametre.module').then((m) => m.ParametreModule),
  },
];

